import {Component} from "@angular/core";
import {
    IonicPage,
    NavController,
    NavParams,
    AlertController, Platform
} from "ionic-angular";
import {HomePage} from "../home/home";
import {ForgotPage} from "../forgot/forgot";
import {AccountProvider} from "../../providers/account/account";
import {TranslateService} from "@ngx-translate/core";
import {Keyboard} from "@ionic-native/keyboard";
import {RegisterPage} from "../register/register";

// import {DemoPage} from "../demo/demo";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: "page-login",
    templateUrl: "login.html",
    providers: [AccountProvider, Platform, Keyboard]
})
export class LoginPage {
    forgotPage = ForgotPage;
    registerPage = RegisterPage;
    public model: any = {};
    public options: any = {};

    public isRegistered = true;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private accountProvider: AccountProvider,
        public alertCtrl: AlertController,
        public translate: TranslateService,
        public platform: Platform,
        public keyboard: Keyboard
    ) {
    }

    ionViewDidLoad() {
        console.log("ionViewDidLoad LoginPage");

        console.log(`KEYBOARD OBJECT`, this.keyboard);
        this.keyboard.disableScroll(true);

        this.accountProvider.loadOptions()
          .subscribe((resp: any) => {
              console.log(resp.data.options);

              if(resp.data.options && resp.data.options.enable_register_account && resp.data.options.enable_register_account.option_value === 'no') {
                  this.isRegistered = false;
              } else {
                  this.isRegistered = true;
              }

          })
    }

    login() {
        if (this.model.email === 'demo' && this.model.password === 'demo') {
            window.localStorage.setItem('TOKEN_KEY', 'demo');
            this.navCtrl.setRoot(HomePage);
            return;
        }

        this.accountProvider.login(this.model).subscribe(
            (resp: any) => {
                console.log(resp);
                if (!resp.status) {
                    const alert = this.alertCtrl.create({
                        title: this.translate.instant("ALERT"),
                        subTitle: resp.messages,
                        buttons: [this.translate.instant("CLOSE")]
                    });
                    alert.present();
                    return;
                }

                window.localStorage.setItem("TOKEN_KEY", resp.data.tokenKey);
                window.localStorage.setItem("USER_ID", resp.data.user.id);
                this.navCtrl.push(HomePage);
            },
            err => {
                console.log(err);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts